// TelcoTrack — minimální zásoba materiálu per AutoCRM sklad (SAP × warehouseId)
// Persistováno v `material_warehouse_min_stock` (ne v AutoCRM).

/**
 * Jednotka `minQuantity`: stejná skladová (usage) jednotka jako zobrazení zásob
 * (`formatMaterialQuantityLabel(..., 'stock')`) — typicky ks / m, ne nákupní balení.
 */
export interface MaterialWarehouseMinStockDto {
  id: string;
  sapCode: string;
  warehouseId: string;
  minQuantity: number;
  updatedAt: string;
  updatedBy: string | null;
}
